import { Injectable } from '@angular/core';

import { BaseStorage } from '../../core/abstractions/base.storage';
import { UserModel } from '../../models/user.model';

@Injectable({
    providedIn: 'root'
})
export class SecurityStorage extends BaseStorage {
    private userInfoKey = 'userInfo';

    constructor() {
        super('security');
    }

    saveUserInfo(userInfo: UserModel): void {
        this.save(userInfo, this.userInfoKey);
    }

    getUserInfo(): UserModel {
        return this.get<UserModel>(this.userInfoKey);
    }

    eraseUserInfo(): void {
        this.remove(this.userInfoKey);
    }
}
